/**
 * The arithmetic behind {@link Pagination}, in its own module so that file
 * exports only a component — which is what react-refresh needs to hot-reload it.
 */

export const pageSizeOptions = [10, 25, 50, 100] as const;

/** How many pages `totalItems` needs — at least one, so an empty list still reads as "page 1 of 1". */
export function pageCount(totalItems: number, pageSize: number): number {
  return Math.max(1, Math.ceil(totalItems / pageSize));
}

/**
 * Keeps a page number inside the range a list currently has. Needed because the range shrinks
 * underneath the user: typing into a search box while on page 6 of 8 can leave one page of results,
 * and a page number past the end renders an empty table that looks like a bug.
 */
export function clampPage(page: number, totalItems: number, pageSize: number): number {
  return Math.min(Math.max(1, page), pageCount(totalItems, pageSize));
}

/** The slice of `items` that belongs on the current page. */
export function pageSlice<T>(items: T[], page: number, pageSize: number): T[] {
  const start = (clampPage(page, items.length, pageSize) - 1) * pageSize;
  return items.slice(start, start + pageSize);
}
